import TYPES from '../../types';

// Domain
import { GoalEarningsEntity } from '../../domain/entities/goal-earnings-entity';
import { GoalEarningsRepository } from '../../domain/repositories/goal-earnings-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Query from '@/modules/shared/domain/use-cases/query';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class GetGoalEarningsQuery extends Query<Promise<GoalEarningsEntity>> {
  @Inject(TYPES.GOAL_EARNINGS_REPOSITORY)
  private readonly repository!: GoalEarningsRepository

  internalExecute(investor_goal_id: string): Promise<GoalEarningsEntity> {
    return new Promise((resolve, reject) => {
      this.repository.get(investor_goal_id)
        .then((item) => {
          resolve(item);
        })
        .catch(reject);
    });
  }
}
